//------------React/Redux
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import React from 'react';

//-------------Helpers
import * as templateHelper from '../../template/templateHelper';
import update from '../../../helpers/update';

//-------------Components
import AboutElement from './components/aboutElement';
import CreateAboutElementModal from './components/createAboutElementModal';
import { TemplateHeader } from '../../template/templateHeader';
import { Form, Icon } from 'semantic-ui-react';

//-------------Constants
import { i18Keys } from './constants/translation';
import {
  AboutElementStringTypes,
  AboutElementIcons
} from './constants/aboutElementType';

//-------------Other
import { v4 as uuidv4 } from 'uuid';
import './index.css';

class AboutElementsBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      draggedIndex: null,
      dragOverIndex: null
    };
    
    this.draggedItem = null;
  }

  // Native HTML5 Drag and Drop handlers
  handleDragStart = (e, index) => {
    this.setState({ draggedIndex: index });
    this.draggedItem = this.props.value.elements[index];
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', '');
  };

  handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    
    if (this.state.dragOverIndex !== index) {
      this.setState({ dragOverIndex: index });
    }
  };

  handleDragEnter = (e, index) => {
    e.preventDefault();
    this.setState({ dragOverIndex: index });
  };

  handleDragLeave = () => {
    this.setState({ dragOverIndex: null });
  };

  handleDrop = (e, dropIndex) => {
    e.preventDefault();

    if (this.state.draggedIndex === null || this.draggedItem === null) return;

    if (this.state.draggedIndex !== dropIndex) {
      const valueCopy = this.getDeepCopy(this.props.value);
      const draggedElement = valueCopy.elements.splice(this.state.draggedIndex, 1)[0];
      valueCopy.elements.splice(dropIndex, 0, draggedElement);

      this.props.onChange(valueCopy);
    }

    this.setState({ draggedIndex: null, dragOverIndex: null });
    this.draggedItem = null;
  };

  handleDragEnd = () => {
    this.setState({ draggedIndex: null, dragOverIndex: null });
    this.draggedItem = null;
  };

  // Helper methods for element display
  getElementIcon = (type) => {
    return AboutElementIcons[type] || 'file';
  };

  getElementStringType = (type) => {
    return AboutElementStringTypes[type] || 'Element';
  };

  onItemChange = (index, value) => {
    const newAboutElements = this.getNewAboutElements(index, value);

    this.props.onChange(newAboutElements);
  };

  getNewAboutElements(index, value) {
    let valueCopy = this.getDeepCopy(this.props.value);

    valueCopy = update.set(valueCopy, `elements.${index}.value`, value);

    return valueCopy;
  }

  getDeepCopy = (value) => {
    return JSON.parse(JSON.stringify(value));
  };

  getAboutElements = () => {
    const aboutElements = this.props.value;

    if (!aboutElements) {
      return null;
    }

    return aboutElements.elements.map((element, index) => (
      <div
        key={element.guid}
        className={`about-element-wrapper ${this.state.draggedIndex === index ? 'dragging' : ''} ${this.state.dragOverIndex === index ? 'drag-over' : ''}`}
        draggable={true}
        onDragStart={(e) => this.handleDragStart(e, index)}
        onDragOver={(e) => this.handleDragOver(e, index)}
        onDragEnter={(e) => this.handleDragEnter(e, index)}
        onDragLeave={this.handleDragLeave}
        onDrop={(e) => this.handleDrop(e, index)}
        onDragEnd={this.handleDragEnd}
      >
        <Form className={`about-element ${element.type}-type`}>
          <Form.Field className="about-element-title-container">
            <label className="about-element-title-label">
              <Icon name={this.getElementIcon(element.type)} size="large" />
              {this.getElementStringType(element.type)}
              <Icon
                name="remove circle"
                className="right-float"
                size="large"
                style={{ cursor: 'pointer' }}
                onClick={() => this.onDeleteAboutElementClick(index)}
              />
            </label>
          </Form.Field>
          <div className="about-element-content">
            <AboutElement
              {...element}
              index={index}
              sessionKey={this.props.sessionKey}
              entity={this.props.entity}
              onChange={this.onItemChange}
            />
          </div>
        </Form>
      </div>
    ));
  };

  onAboutElementAdd = (type) => {
    const valueCopy = this.props.value
      ? this.getDeepCopy(this.props.value)
      : { elements: [] };
    valueCopy.elements.push({
      guid: uuidv4(),
      value: '',
      type: type
    });
    this.props.onChange(valueCopy);
  };

  onDeleteAboutElementClick = (index) => {
    const valueCopy = this.getDeepCopy(this.props.value);
    valueCopy.elements.splice(index, 1);
    this.props.onChange(valueCopy);
  };

  onModalOpen = () => {
    this.setState({
      isModalOpen: true
    });
  };

  onModalClose = () => {
    this.setState({
      isModalOpen: false
    });
  };

  render() {
    const aboutElements = this.getAboutElements();
    const i18Key = 'template.page.content.about-elements';

    return (
      <div className="about-elements-container">
        <Form.Field>
          <label>{this.props.label}</label>
          {this.props.subtext && (
            <div className="input-sub">{this.props.subtext}</div>
          )}
        </Form.Field>
        {aboutElements}
        <CreateAboutElementModal
          open={this.state.isModalOpen}
          onClose={this.onModalClose}
          onAboutElementAdd={this.onAboutElementAdd}
        />
        <div className="add-about-element-container" onClick={this.onModalOpen}>
          <span className="add-ticket-text">
            {I18n.t(`${i18Key}.${i18Keys.ADD_ABOUT_ELEMENT}`)}
          </span>
        </div>
        <TemplateHeader
          as="h5"
          label="template.page.content.setup.campaign-story.description"
        />
      </div>
    );
  }
}

const mapState = (state, ownProps) => {
  const value = templateHelper.getValue(state.templateBuilderEx, ownProps.path);

  return {
    value
  };
};

const withoutContext = connect(mapState, null);
export default withoutContext(AboutElementsBuilder);
export { withoutContext };
